import { CollapsibleHeader } from '@fiverr-private/disclosure';
import withClick from '../helpers/withClick';

export default withClick(CollapsibleHeader);
